import * as S from './styled'

import React from 'react'
import { getAdjustmentValue } from '@app/evaluation-core'

import HoleMenu from '@app/evaluation/components/HoleMenu'
import RoundedButton from '@app/ui/rounded-button/RoundedButton'

import useAdjustment from '@common/hooks/useAdjustment'
import useEvaluationUser from '@common/hooks/useEvaluationUser'
import Spacer from 'react-styled-spacer'
import Feather from '@ovaeasy/react-native-vector-icons/Feather'
import { LoadingContainer } from '@app/evaluation-adjustments/components/AdjustmentFactors.styles'
import 'react-loading-skeleton/dist/skeleton.css'

interface SideBarProps {
  collapsedMode: any
  holeDecrementState: () => void
  holeIncrementState: () => void
  dropMenuRef: any
}

const EvaluationSideBarHeader = ({
  collapsedMode,
  holeDecrementState,
  holeIncrementState,
  dropMenuRef,
}: SideBarProps) => {
  const isPhone = window.innerWidth <= 767

  const { view } = useEvaluationUser()
  const adjustments = useAdjustment()

  const par = getAdjustmentValue('hole', view, 'Par', adjustments)

  const spinner = (
    <LoadingContainer>
      <Feather name="loader" size={!isPhone ? 12 : 6} />
    </LoadingContainer>
  )

  const parValue = !adjustments || !adjustments.adjustments ? spinner : par

  return (
    <S.EvalSideBarTop>
      {!collapsedMode ? (
        <>
          <S.EvalSideBarTopCont>
            <S.EvalSideBarMenus>
              <div style={{ width: '100%' }}>
                <S.ParLengthContainer>
                  <S.ParLengthLabel>Par</S.ParLengthLabel>
                  <S.ParLengthValue>{parValue || ''}</S.ParLengthValue>
                </S.ParLengthContainer>
                {!isPhone ? <Spacer h={40} /> : <Spacer h={20} />}
              </div>
            </S.EvalSideBarMenus>
            <S.HoleButtonContainter>
              <RoundedButton
                icon={
                  <Feather
                    name="chevron-left"
                    size={20}
                    style={{ color: 'white' }}
                  />
                }
                title=""
                style={{ color: 'white' }}
                onPress={() => {
                  holeDecrementState()
                }}
              />
              <div style={{ width: '5px' }} />
              <HoleMenu reference={dropMenuRef} />
              <div style={{ width: '5px' }} />
              <RoundedButton
                title=""
                icon={
                  <Feather
                    name="chevron-right"
                    size={20}
                    style={{ color: 'white' }}
                  />
                }
                onPress={() => {
                  holeIncrementState()
                }}
              />
            </S.HoleButtonContainter>
          </S.EvalSideBarTopCont>
        </>
      ) : (
        <S.CollapsedSideBarContainer>
          <S.CollapsedInputContainer>
            <S.CollapsedContainer>
              <S.ParLengthLabel>Hole</S.ParLengthLabel>
              <S.ParLengthValue>{view?.hole + 1 || ''}</S.ParLengthValue>
            </S.CollapsedContainer>
            <S.ParLengthContainer>
              <S.ParLengthLabel>Par</S.ParLengthLabel>
              <S.ParLengthValue>{par || ''}</S.ParLengthValue>
            </S.ParLengthContainer>
            <Spacer h={26} />
            <S.CollapsedContainer>
              <RoundedButton
                title=""
                icon={
                  <Feather
                    name="chevron-left"
                    size={20}
                    style={{ color: 'white' }}
                  />
                }
                onPress={() => {
                  holeDecrementState()
                }}
              />
              <Spacer w={8} />
              <RoundedButton
                title=""
                icon={
                  <Feather
                    name="chevron-right"
                    size={20}
                    style={{ color: 'white' }}
                  />
                }
                onPress={() => {
                  holeIncrementState()
                }}
              />
            </S.CollapsedContainer>
          </S.CollapsedInputContainer>
        </S.CollapsedSideBarContainer>
      )}
    </S.EvalSideBarTop>
  )
}

export default EvaluationSideBarHeader
